export const dataTypes = [
  {
    type: "Text",
    value: "string",
  },
  {
    type: "Date",
    value: "date",
  },
  {
    type: "Date & Time",
    value: "date_time",
  },
  {
    type: "Time",
    value: "time",
  },
  {
    type: "Number",
    value: "numeric",
  },
  {
    type: "Percentage",
    value: "percentage",
  },
  {
    type: "Scientific",
    value: "scientific",
  },
];

export const sheets = [
  {
    name: "Sheet 1",
    value: "sheet1",
  },

  {
    name: "Sheet 2",
    value: "sheet2",
  },
  {
    name: "Sheet 3",
    value: "sheet3",
  },
  {
    name: "Sheet 4",
    value: "sheet4",
  },
];
